import { Icon } from '../common';

export type StaffViewTab = 'daily' | 'shifts' | 'info';

// The staff view's three tabs in a bottom bar — the customer portal's pattern,
// replacing the segmented control under the greeting (shift-alerts-info-tab
// AC1, decision roster-change-notify-info-tab §1). Daily keeps today's leaving
// count; Info carries a dot while shift alerts are off on this phone (AC2) —
// the only nudge the feature makes.
export function StaffBottomBar({
  tab,
  onChange,
  todayCount,
  alertsOff,
}: {
  tab: StaffViewTab;
  onChange: (t: StaffViewTab) => void;
  todayCount: number;
  alertsOff: boolean;
}) {
  const cell = (key: StaffViewTab, icon: string, label: string, extra?: React.ReactNode) => (
    <button
      key={key}
      type="button"
      role="tab"
      className={'sbb-item' + (tab === key ? ' active' : '')}
      aria-selected={tab === key}
      onClick={() => onChange(key)}
    >
      <span className="sbb-icon">
        <Icon name={icon} size={22} />
        {extra}
      </span>
      <span>{label}</span>
    </button>
  );
  return (
    <nav className="staff-bottom-bar" role="tablist" aria-label="Staff view">
      {cell('daily', 'home', 'Daily', todayCount > 0 ? <span className="count">{todayCount}</span> : undefined)}
      {cell('shifts', 'clock', 'Shifts')}
      {cell('info', 'info', 'Info', alertsOff ? <span className="sbb-dot" aria-label="Shift alerts are off" /> : undefined)}
    </nav>
  );
}
